import { helper } from '@ember/component/helper';
import {
  ideaStatusBgColors,
  ideaStatusTextColors,
} from 'scaleflow/utils/colorClasses';

export default helper(function ideaStatusColorClass(
  [status]: [string] /*, named*/,
) {
  const bgColor =
    ideaStatusBgColors.get(status?.toUpperCase()) ?? 'bg-gray-100';
  const textColor =
    ideaStatusTextColors.get(status?.toUpperCase()) ?? 'text-gray-700';
  return `${bgColor} ${textColor}`;
});
